<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">{{ bizDepartFlag ? '部门' : '机构' }}导入文件</label>
                </div>
                <div class="form-value">
                    <swb-file-upload fileGroup="retailer.com.import" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label"></div>
                <div class="form-value align-right">
                    <a class="swb-btn-link" @click="downloadTmp">下载创建{{ bizDepartFlag ? '部门' : '机构' }}模板</a>
                </div>
            </div>
        </div>
        <el-table class="thin" :data="comImpInfoList" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
            <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
            <el-table-column prop="name" label="机构名称" class-name="required" width="160">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.name"/>
                </template>
            </el-table-column>
            <el-table-column prop="no" label="机构编号" width="150">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.no.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.no" :title="rows.row.validateInfo.no.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.no"/>
                </template>
            </el-table-column>
            <el-table-column prop="code" label="机构代码" width="150">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.code.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.code" :title="rows.row.validateInfo.code.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.code"/>
                </template>
            </el-table-column>
            <el-table-column prop="code" label="机构二维码Code" width="150" v-if="!bizDepartFlag">
                <template slot-scope="rows">
                    <span v-if="rows.row.orgType == 1">
                        <input type="text" style="width:100%" v-model="rows.row.qrCode"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="orgType" label="机构类型" width="160">
                <template slot-scope="rows">
                    <el-select v-model="rows.row.orgType" disabled @change="orgTypeChangefunc(rows.row)">
                        <el-option v-for="item in orgTypeList" :label="item.text" :value="item.value"/>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="bizUnitType" label="业务单元类型" width="160" v-if="!bizDepartFlag">
                <template slot-scope="rows">
                    <el-select v-model="rows.row.bizUnitType">
                        <el-option v-for="item in bizUnitTypeList" :label="item.text" :value="item.value"/>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="comSysName" width="150" label="系统名称">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.comSysName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.comSysName"
                           :title="rows.row.validateInfo.comSysName.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.comSysName"/>
                </template>
            </el-table-column>
            <el-table-column prop="contactName" width="150" label="联系人姓名">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.contactName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.contactName"
                           :title="rows.row.validateInfo.contactName.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.contactName"/>
                </template>
            </el-table-column>
            <el-table-column prop="contactTel" width="120" label="联系电话">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.contactTel.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.contactTel"
                           :title="rows.row.validateInfo.contactTel.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.contactTel"/>
                </template>
            </el-table-column>
            <el-table-column prop="contactEmail" width="200" label="联系邮箱">
                <template slot-scope="rows">
                    <input type="text" v-if="!rows.row.validateInfo.contactEmail.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 100%" v-model="rows.row.contactEmail"
                           :title="rows.row.validateInfo.contactEmail.errorMsg"/>
                    <input type="text" v-else style="width:100%" @change="commonChangeEvent" v-model="rows.row.contactEmail"/>
                </template>
            </el-table-column>
            <el-table-column label="机构标签" align="center" v-if="bizUnitType == 1">
                <el-table-column prop="tagId" label="设置" width="100" :render-header="setTag">
                    <template slot-scope="rows">
                        <el-select v-model="rows.row.tagId">
                            <el-option v-for="item in retailerShopTagList" :label="item.name" :value="item.id"/>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="realComCode" width="120" label="实体公司编码" v-if="!bizDepartFlag">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.realComCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="costCenterCode" width="120" label="成本中心编码" v-if="!bizDepartFlag">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.costCenterCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="prftCenterCode" width="120" label="利润中心编码" v-if="!bizDepartFlag">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.prftCenterCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="bizAreaCode" width="120" label="经营区域编码">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.bizAreaCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="bizFormCode" width="120" label="经营业态编码">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.bizFormCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="mgmtSmlAreaCode" width="120" label="管理区域编码">
                <template slot-scope="rows">
                    <input type="text" style="width:100%" v-model="rows.row.mgmtSmlAreaCode"/>
                </template>
            </el-table-column>
            <el-table-column prop="indepenAcnt" width="100" label="独立核算">
                <template slot-scope="rows">
                    <input type="checkbox" style="width:100%" v-model="rows.row.indepenAcnt"/>
                </template>
            </el-table-column>
            <el-table-column prop="memo" label="操作" align="left" width="80">
                <template slot-scope="rows">
                    <a class="swb-btn swb-btn-link" @click="removeRow(rows.$index)">移除</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-com-imp-check',
        desc: '机构导入检查',
        props: ["bizDepartFlag", "bizUnitType"],
        data: function () {
            return {
                comImpInfoList: [],

                theLoading: null,
                multipleSelection: [],
                max_quantity_per_item: 500,
                retailerShopTagList: [],
                orgTypeList: getEnumList('orgType'),
                bizUnitTypeList: []
            }
        },
        created: function () {
            // 业务单元类型
            let bizUnitTypeList = getEnumList('bizUnitType');
            let dataList = [];
            for (let i = 0; i < bizUnitTypeList.length; i++) {
                let row = bizUnitTypeList[i];
                if (row.name == 'Plain' || row.name == 'Shop') {
                    dataList.push(row);
                }
            }
            this.bizUnitTypeList = Utils.merge([], dataList);
            //
            this.getShopTag();
        },
        methods: {
            getShopTag: function () {
                let postData = {};
                let self = this;
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagList(postData, function (result) {
                    loading.hide();
                    if (result.type == "info") {
                        self.retailerShopTagList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            onBeforeUpload: function (fileItems, uploader) {
                if (fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析设备文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                //
                let self = this;
                if (result.type === 'info') {
                    let files = result.data.files;
                    let file = files[0];
                    self.openShopDeviceImpCheckDlg(file);
                } else {
                    this.$message.warning(result.message);
                }
            },

            openShopDeviceImpCheckDlg(filter) {
                let self = this;
                let theLoading = MsgBox.loading();
                let comImpInfoList = filter.extra.comImpInfoList;
                comImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        name: {validateOk: true},
                        comSysName: {validateOk: true},
                        contactName: {validateOk: true},
                        contactTel: {validateOk: true},
                        contactEmail: {validateOk: true},
                    };
                    if (self.bizDepartFlag) {
                        el.orgType = 0;
                    } else {
                        el.orgType = 1;
                    }
                });
                this.comImpInfoList = comImpInfoList;

                self.checkData();
                theLoading.close();
            },
            markSelectedRowClassName(row) {
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            quantityChangeEvent(value) {
                this.checkData();
            },
            orgTypeChangefunc: function (row) {
                if (row.orgType != 1) {
                    row.qrCode = "";
                }
            },
            commonChangeEvent() {
                this.checkData();
            },
            checkData() {
                let self = this;
                let rows = this.comImpInfoList.clone();
                for (let i = 0; i < rows.length; i++) {
                    let comImpDto = rows[i];
                    comImpDto.validateInfo = {
                        name: {validateOk: true},
                        comSysName: {validateOk: true},
                        contactName: {validateOk: true},
                        contactTel: {validateOk: true},
                        contactEmail: {validateOk: true},
                        no: {validateOk: true},
                        code: {validateOk: true},
                    };
                    // 检查修正 [机构名称]
                    if (!Utils.isNoB(comImpDto.name)) {
                        if (comImpDto.name.length > 20) {
                            comImpDto.validateInfo.batchNo = {
                                validateOk: false,
                                errorMsg: "[机构名称]单元长度最大60，当前[" + comImpDto.name.length + "]"
                            };
                        }
                    } else {
                        comImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[机构名称]单元不能为空"
                        };
                    }
                    if (!Utils.isNoB(comImpDto.no)) {
                        if (comImpDto.no.length > 15) {
                            comImpDto.validateInfo.no = {
                                validateOk: false,
                                errorMsg: "[机构编号]不可大于15个字符"
                            };
                        }
                    }
                    if (!Utils.isNoB(comImpDto.code)) {
                        if (comImpDto.code.length > 15) {
                            comImpDto.validateInfo.code = {
                                validateOk: false,
                                errorMsg: "[机构代码]不可大于15个字符"
                            };
                        }
                    }

                    // 检查修正 [系统名称]
                    if (!Utils.isNoB(comImpDto.comSysName)) {
                        if (comImpDto.comSysName.length > 30) {
                            comImpDto.validateInfo.comSysName = {
                                validateOk: false,
                                errorMsg: "[系统名称]单元长度最大30，当前[" + comImpDto.comSysName.length + "]"
                            };
                        }
                    } else {
                        comImpDto.validateInfo.comSysName = {
                            validateOk: false,
                            errorMsg: "[系统名称]单元不可为空！]"
                        };
                    }

                    // 检查修正 [联系人姓名]
                    if (!Utils.isNoB(comImpDto.contactName)) {
                        if (comImpDto.contactName.length > 30) {
                            comImpDto.validateInfo.contactName = {
                                validateOk: false,
                                errorMsg: "[联系人姓名]单元长度最大30，当前[" + comImpDto.contactName.length + "]"
                            };
                        }
                    }
                    //检查修正 [联系人电话]
                    if (!Utils.isNoB(comImpDto.contactTel)) {
                        if (!Utils.isPhoneNo(comImpDto.contactTel)) {
                            comImpDto.validateInfo.contactTel = {
                                validateOk: false,
                                errorMsg: "[联系人电话]不正确"
                            };
                        }
                    }

                    //检查修正 [联系人邮箱]
                    if (!Utils.isNoB(comImpDto.contactEmail)) {
                        if (!Utils.isEmail(comImpDto.contactEmail)) {
                            comImpDto.validateInfo.contactEmail = {
                                validateOk: false,
                                errorMsg: "[联系人邮箱]不正确"
                            };
                        }
                    }
                }
                this.comImpInfoList = rows;
            },
            checkRequestData: function (comImpInfoList) {
                let comName = null;
                for (let i = 0; i < comImpInfoList.length; i++) {
                    let comImpInfo = comImpInfoList[i];
                    //
                    let validateInfo = comImpInfo.validateInfo;
                    let checKName = validateInfo.name.validateOk;
                    let comSysName = validateInfo.comSysName.validateOk;
                    let contactName = validateInfo.contactName.validateOk;
                    let checkContactTel = validateInfo.contactTel.validateOk;
                    let checkContactEmail = validateInfo.contactEmail.validateOk;
                    let checkNo = validateInfo.no.validateOk;
                    let checkCode = validateInfo.code.validateOk;
                    //
                    if (!(checKName && comSysName && contactName && checkContactTel && checkContactEmail && checkNo && checkCode)) {
                        comName = comImpInfo.name;
                        return comName;
                    }
                }
                return comName;
            },
            getDlgResult: function () {
                let result = {};
                result.type = 'info';
                let comImpInfoList = this.comImpInfoList || [];
                if (Utils.isNoB(comImpInfoList) || comImpInfoList.length < 0) {
                    result.type = 'warn';
                    result.message = "导入数据不可为空!";
                    return result;
                } else {
                    // 提交前检查-数据是否合法
                    let comName = this.checkRequestData(comImpInfoList);
                    if (!Utils.isNoB(comName) || comName == "") {
                        result.type = 'warn';
                        result.message = "机构【" + comName + "】数据未通过检查!";
                        return result;
                    }
                    if (this.bizUnitType == 1) {
                        let retailerShopTagList = this.retailerShopTagList || [];
                        for (let i = 0; i < comImpInfoList.length; i++) {
                            let comImpInfo = comImpInfoList[i];
                            let retailerShopTag = retailerShopTagList.find(function (row) {
                                if (row.id == comImpInfo.tagId) {
                                    return row;
                                }
                            });
                            if (!Utils.isNoB(retailerShopTag)) {
                                comImpInfo.tagName = retailerShopTag.name;
                            }
                        }
                    }
                    result.data = comImpInfoList;
                }
                return result;
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            removeRow: function (index) {
                let self = this;
                let comImpInfoList = self.comImpInfoList;
                comImpInfoList.splice(index, 1);
                self.comImpInfoList = Utils.merge([], comImpInfoList);
            },
            downloadTmp: function () {
                let self = this;
                // 下载模版
                let url = "/api/retailer/imp/model/template/file/download?bizDepartFlag=" + self.bizDepartFlag;
                if (!Utils.isNoB(self.comId)) {
                    url = url + "&shopId=" + self.comId;
                }
                Utils.setPageUrl(getAppUrl(url), '_blank');
            },
            setTag: function (h) {
                let self = this;
                let retailerShopTagList = self.retailerShopTagList || [];
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let multipleSelection = self.multipleSelection || [];
                                if (multipleSelection.length <= 0) {
                                    MsgBox.warning("请选择对应的机构信息");
                                    return;
                                }
                                let theDlg = Vue.$showDialog({
                                    title: "设置机构标签",
                                    width: 580,
                                    height: 300,
                                    showCloseBtn: true,
                                    template: '<div class="form-info">' +
                                        '<div class="form-row">' +
                                        '<div class="form-label">' +
                                        '<label>机构标签</label>' +
                                        '</div>' +
                                        '<div class="form-value width-2x">' +
                                        '<el-select v-model="tagId" clearable placeholder="请选择">' +
                                        '<el-option v-for="item in retailerShopTagList" :key="item.id" :label="item.name" :value="item.id">' +
                                        '</el-option>' +
                                        '</el-select>' +
                                        '</div>' +
                                        '</div>' +
                                        '</div>',
                                    data: {
                                        retailerShopTagList: retailerShopTagList,
                                        tagId: null,

                                    },
                                    okClicked: function () {
                                        let tagId = this.tagId;
                                        let retailerShopTag = retailerShopTagList.find(function (row) {
                                            if (row.id == tagId) {
                                                return row;
                                            }
                                        })
                                        for (let i = 0; i < self.multipleSelection.length; i++) {
                                            let tmpRow = self.multipleSelection[i];
                                            let model = self.comImpInfoList.find(function (row) {
                                                return row.id == tmpRow.id
                                            });

                                            model.tagId = tagId;
                                            model.tagName = retailerShopTag.name;
                                        }
                                    },
                                    methods: {}
                                });
                            }
                        }
                    }, '设置')
                ])

            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }

    .el-table .warning-row {
        background: #FFAD86;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComImpCheck.vue